import { reviewsList } from '../list/reviews';

export const reviews = {
  title: 'Отзывы',
  list: reviewsList,
};
